import { useAccountActionPermissions } from "@zapier/client";
import { AppFilter, OwnerFilter } from "@zapier/shared";
import { AssetTypes } from "@zapier/utils";
import styles from "./TemplatesFilters.module.css";

export function TemplatesFilters() {
  const { allowTeams } = useAccountActionPermissions();
  return (
    <div className={styles.root}>
      {allowTeams && <OwnerFilter assetType={AssetTypes.Template} />}
      <AppFilter assetType={AssetTypes.Template} />
    </div>
  );
}
